@let _shipment = shipment();

<div class="shipment-info">
  {{ _shipment.Courier | titlecase }} {{ _shipment.Weight }}kg
</div>

<div class="qrcode">
  @if (!_shipment.QrCodeImageData) {
    <qrcode
      [qrdata]="_shipment.ShipmentId"
      [width]="200"
      [errorCorrectionLevel]="'M'" />
  } @else {
    <img [src]="_shipment.QrCodeImageData" />
  }
</div>

@if(displayTrackingInfo()) {
  <div class="tracking-link-wrapper">
    <div class="tracking-link-label">Spårningslänk</div>
    <div>
      <a class="tracking-link" [href]="shipmentTrackingLink()" target="_blank">
        {{ shipmentTrackingLink() }}
      </a>
    </div>
  </div>
}
